<template>
  <div class="index w1400">
    <el-row :gutter="45" class="mt26">
      <el-col :span="24" :md="11" class="custom">
        <el-carousel :autoplay="true" indicator-position="none">
          <el-carousel-item  v-for="(item,i) in swiperList" :key='i'>
            <div class="index-swiper-item">
              <img :src='item.ak002' class="swiper-slide" @click="navto(item.ak003)">
              <div class="swiper-text">
                 <div class="transbg"></div>
                 <div >{{item.ak001}}</div>
               </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </el-col>
      <el-col :span="24" :md="13">
        <div class="rules mt0 media-mt18">
          <div class="index-title">
            <img src="../../assets/icon4.png" alt="" class="titleimg">
            <span class="color">行业管理动态</span>
          </div>
          <div class="morerule">
            <span>
              <router-link to="dynamic/5/29">更多</router-link>
            </span>
            <img src="../../assets/icon3.png" alt="" class="more">
          </div>
        </div>
        <div class="weight font24 mt18 mb24 red">重点资讯标题</div>
        <ul>
          <li v-for="item in state">
            <div class="liimg" @click="toNewsInf(item)">
              <img src="../../assets/list.png" alt="" class="bloock">
              <span class="cleartext text font16">{{item.ty002}}</span>
            </div>
            <span class="font16">{{item.createdt | formatTime}}</span>
          </li>
        </ul>
      </el-col>
    </el-row>
    <el-row :gutter="55">
      <el-col :span="24" :md="11">
        <div class="rules">
          <div class="index-title">
            <img src="../../assets/icon14.png" alt="" class="titleimg">
            <span class="color">政策法规</span>
          </div>
          <div class="morerule">
            <span>
              <router-link to="active/0/2">更多</router-link>
            </span>
            <img src="../../assets/icon3.png" alt="" class="more">
          </div>
        </div>
        <ul>
          <li v-for="item in Policies">
            <div class="liimg" @click="toNewsInf(item)">
              <img src="../../assets/list.png" alt="" class="bloock">
              <span class="cleartext text font16">{{item.ty002}}</span>
            </div>
            <span class="font16">{{item.createdt | formatTime}}</span>
          </li>
        </ul>
      </el-col>
      <el-col :span="24" :md="13">
        <div class="listimg media-new-news-card">
         <div class="imgtext">
            <img src="../../assets/index1.png" alt="" @click="navto('energy')">
            <span class="text-name">新能源车辆信息</span>
         </div>
         <div class="imgtext">
            <img src="../../assets/index3.png" alt="" @click="navto('distribution')">
            <span class="text-name">三级物流节点</span>
         </div>
         <div class="imgtext">
             <img src="../../assets/index2.png" alt="" @click="navto('charging')">
            <span class="text-name">充电站(桩)</span>
         </div>
        </div>
        <div class="rules mt14">
          <div class="font20">您可能想了解(最新资讯)</div>
          <div class="morerule">
            <span>
              <router-link to="newest/0/5">更多</router-link>
            </span>
            <img src="../../assets/icon3.png" alt="" class="more">
          </div>
        </div>
        <ul class="mt24">
          <li v-for="item in latest">
            <div class="liimg" @click="toNewsInf(item)">
              <img src="../../assets/list.png" alt="" class="bloock">
              <span class="cleartext text font16">{{item.ty002}}</span>
            </div>
            <span class="font16">{{item.createdt | formatTime}}</span>
          </li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="mt14">
        <el-carousel height="11.4rem" direction="vertical" :autoplay="true" :loop='true'>
          <el-carousel-item v-for="item in banner" :key="item">
            <img :src="item" alt="" class="banner swiper-slide">
          </el-carousel-item>
        </el-carousel>
      </el-col>
    </el-row>
    <el-row :gutter="55" class="mt18" align="bottom">
      <el-col :span="24" :md="11">
        <div class="rules mt0">
          <div class="index-title">
            <img src="../../assets/icon4.png" alt="" class="titleimg">
            <span class="color">互联互通</span>
          </div>
        </div>
        <el-card class=" mt24" :body-style="{ padding: '1.6rem' }">
          <div class="box-card">
            <div class="text-item media-outWeb" v-for="item in webs" @click="navOutWeb(item.web)">
              <img src="../../assets/link-a.png" alt="">
              <div>{{item.name}}</div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="24" :md="13">
        <div class="rules mt0 media-mt18">
          <div class="index-title">
            <img src="../../assets/icon14.png" alt="" class="titleimg">
            <span class="color">优化营商环境</span>
          </div>
          <div class="morerule">
            <span>
              <router-link to="newest/1/2">更多</router-link>
            </span>
            <img src="../../assets/icon3.png" alt="" class="more">
          </div>
        </div>
        <ul>
          <li v-for="(item,i) in environment">
            <div class="liimg" @click="toNewsInf(item)">
              <img src="../../assets/list.png" alt="" class="bloock">
              <span class="cleartext text font16">{{item.ty002}}</span>
            </div>
            <span class="font16">{{item.createdt | formatTime}}</span>
          </li>
        </ul>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="bg">
        <div class="func-line" v-for="(item,i) in func">
          <div class="func" @click="clickFunc(item)">
            <img :src="item.icon" alt="">
            <div>{{item.name}}</div>
          </div>
          <span class="line" v-if="i!=5"></span>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="19">
      <el-col :span="24" :md="16">
        <div class="rules mt0">
          <div class="index-title">
            <img src="../../assets/icon7.png" alt="" class="titleimg">
            <span class="color">平台数据</span>
          </div>
        </div>
        <el-card class="resource mt24 media-resource" :body-style="{ padding: '1.6rem' }">
          <div class="resource-box media-resource-padding">
            <div class='resitem'>
              <div class="pad">
                <div class="font20 bold">近期货物信息统计</div>
                <!-- <div class="font16">（万吨）</div> -->
                 <div class="font40 color">{{Platform.goodsWeight | formatNum}}<span class="font12">{{Platform.companySum>10000?"万吨":"吨"}}</span></div>
<!--                 <div class="font40 color">330<span class="font12">吨</span></div>-->
              </div>
              <span class="linesolid"></span>
            </div>
            <div class='resitem'>
              <div class="pad">
                <div class="font20 bold">物流企业</div>
                <!-- <div class="font16">（万吨）</div> -->
                <div class="font40 color">{{Platform.companySum | formatNum}} <span class="font12">{{Platform.companySum>10000?"万家":"家"}}</span></div>
              </div>
              <span class="linesolid"></span>
            </div>
            <div class='resitem'>
              <div class="pad">
                <div class="font20 bold">新能源车辆总数</div>
                <!-- <div class="font16">（万吨）</div> -->
                <div class="font40 color">{{Platform.vehicleSumEnergy | formatNum}} <span class="font12">{{Platform.vehicleSumEnergy>10000?"万辆":"辆"}}</span></div>
              </div>
              <!-- <span class="linesolid" v-if="i!=2"></span> -->
            </div>
          </div>
          <div class="resource-box mt18">
            <div class='resitem'>
              <div class="pad">
                <div class="font20 bold">近期车辆信息统计</div>
                <!-- <div class="font16">（万吨）</div> -->
                <div class="font40 color">{{Platform.vehicleSum | formatNum}} <span class="font12">{{Platform.vehicleSum>10000?"万辆":"辆"}}</span></div>
              </div>
              <span class="linesolid" v-if="i!=2"></span>
            </div>
            <div class='resitem'>
              <div class="pad">
                <div class="font20 bold">充电站(桩)总数</div>
                <!-- <div class="font16">（万吨）</div> -->
                <div class="font40 color">{{Platform.chargingPileSum | formatNum}} <span class="font12">{{Platform.chargingPileSum>10000?'万座':'座'}}</span></div>
              </div>
              <span class="linesolid"></span>
            </div>
            <div class='resitem'>
              <div class="pad">
                <div class="font20 bold">仓储资源利用率</div>
                <!-- <div class="font16">（万吨）</div> -->
                <div class="font40 color">{{(Platform.houseRent/(Platform.houseRent+Platform.houseUnRent)*100) | formatNum}}%</div>
              </div>
              <!-- <span class="linesolid" v-if="i!=2"></span> -->
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="24" :md="8">
        <div class="rules mt0 media-mt18">
          <div class="index-title">
            <img src="../../assets/icon5.png" alt="" class="titleimg">
            <span class="color">节能减排</span>
          </div>
        </div>
        <el-card class="resource mt24 reduce media-resource" :body-style="{ padding: '1.6rem' }">
<!--          <div class="pad">-->
          <div>
            <div class="left font20">碳排放减少量</div>
             <div class="left font40 color pr100">{{Platform.carbon | formatKgNum}} <span class="font12">{{Platform.carbon>10000000000?'万吨':'吨'}}</span></div>
<!--            <div class="left font40 color pr100">1118<span class="font12">吨</span></div>-->
            <div class="left font20">硫排放减少量</div>
             <div class="left font40 color pr100">{{Platform.sulfur | formatKgNum}} <span class="font12">{{Platform.sulfur>10000000000?'万吨':'吨'}}</span></div>
<!--            <div class="left font40 color pr100">828<span class="font12">吨</span></div>-->
            <div class="left font20">油耗减少量</div>
             <div class="left font40 color pr100">{{Platform.oil | formatKgNum}} <span class="font12">{{Platform.oil>10000000000?'万升':'升'}}</span></div>
<!--            <div class="left font40 color pr100">3400<span class="font12">升</span></div>-->
          </div>
        </el-card>
      </el-col>
    </el-row>

        <el-row :gutter="19" style="height: 600px;">
          <el-col :span="24" :md="16">
            <div class="rules mt0">
              <div class="index-title">
                <img src="../../assets/icon7.png" alt="" class="titleimg">
                <span class="color">降耗对比</span>
              </div>
            </div>
            <el-card class="resource mt24 media-resource" :body-style="{ padding: '1.6rem' }"  style="height: 500px;">
                <div style="height: 450px; background-color: white">
                    <!-- <div id="yearEnergyChartBar" style="width: 935px;height:100%;"></div> -->
                    <!-- <v-LogisticEnergyChart style="width: 935px;height:100%;" ></v-LogisticEnergyChart> -->
                    <iframe src="http://bigdatanew.bysunnm.com/#/logisticEnergyChart" width="850px" height="100%"
                    style="border: none;"  scrolling="no"
                    ></iframe>
                </div>
            </el-card>
          </el-col>
          <el-col :span="24" :md="8">
            <div class="rules mt0 media-mt18">
              <div class="index-title">
                <img src="../../assets/icon5.png" alt="" class="titleimg">
                <span class="color">单位能耗</span>
              </div>
            </div>
            <el-card class="resource mt24 reduce media-resource" :body-style="{ padding: '1.6rem' }" style="height: 500px;">
              <div>
                <!-- UnitTransEnergyQty_Oil单位周转能耗油，UnitTransEnergyQty_Elec单位周转能耗电，DeliveryCost吨公里成本，CommonDeliveryRate共同配送率 -->

                <div class="left font20">单位周转能耗</div>
                 <div class="left font40 color pr100">{{energyValueData.field2}} <span class="font12">升</span></div>
                <div class="left font20">吨公里成本</div>
                 <div class="left font40 color pr100">{{energyValueData.field3}} <span class="font12">元</span></div>
                <div class="left font20">共同配送率</div>
                 <div class="left font40 color pr100">{{energyValueData.field4}}  <span class="font12">%</span></div>
                <div class="left font20">日均单车行驶里程为</div>
                 <div class="left font40 color pr100">{{energyValueData.field5}} <span class="font12">公里</span></div>
                <div class="left font20">周转量</div>
                 <div class="left font40 color pr100">{{energyValueData.field6}} <span class="font12">吨</span></div>
              </div>
            </el-card>
          </el-col>
        </el-row>


    <el-row :gutter="24" class="mt18 mb53">
      <el-col :span="24" :md="8" class="media-mt18">
        <el-card :body-style="{ padding: '0' }">
          <div class="bot-title">
            <div class="color font24">订单信息</div>
            <div class="font16"> <router-link to="supplyOfGoods">更多</router-link></div>
          </div>
          <div class="eee">
            <div class="botHeader odd">
              <div class="font20">订单日期</div>
              <div class="font20">货物名称</div>
              <div class="font20">收货地址</div>
            </div>
            <div :class="{botHeader:true,even:i%2==0,odd:i%2!=0,translist:i==CarsIndex}" v-for="(item,i) in goods[0]">
              <div class="font16 cleartext" style="width: 115px;">{{item.field1}}</div>
              <div class="font16 cleartext" style="width: 165px;">{{item.field2}}</div>
              <div class="font16 cleartext" style="width: 170px;">{{item.field3}}</div>
            </div>
          </div>
         <!-- <router-link to="supplyOfGoods">
            <div class="center font16 bot-more">查看更多</div>
          </router-link> -->
        </el-card>
      </el-col>
      <el-col :span="24" :md="8" class="media-mt18">
        <el-card :body-style="{ padding: '0' }">
          <div class="bot-title">
            <div class="color font24">配送车辆</div>
            <div class="font16"><router-link to='options'>更多</router-link></div>
          </div>
          <div class="eee">
            <div class="botHeader odd">
              <div class="font20" style="width: 115px;">车牌号</div>
              <div class="font20" style="width: 170px;">所属企业</div>
              <div class="font20" style="width: 180px;">当前位置</div>
            </div>
            <div :class="{botHeader:true,even:i%2==0,odd:i%2!=0,translist:i==GoodsIndex}" v-for="(item,i) in cars[0]">
              <div class="font16 cleartext" style="width: 115px;">{{item.field1}}</div>
              <div class="font16 cleartext" style="width: 170px;">{{item.field2}}</div>
              <div class="font16 cleartext" style="width: 180px;">{{item.field4}}</div>
            </div>
          </div>
         <!-- <router-link to='options'>
            <div class="center font16 bot-more">查看更多</div>
          </router-link> -->
        </el-card>
      </el-col>

      <!-- <el-col :span="24" :md="8" class="media-mt18">
        <el-card :body-style="{ padding: '0' }">
          <div class="bot-title">
            <div class="color font24">最新货源</div>
            <div class="font16"> <router-link to="supplyOfGoods">更多</router-link></div>
          </div>
          <div class="eee">
            <div class="botHeader odd">
              <div class="font20">货物名称</div>
              <div class="font20">起始地点</div>
              <div class="font20">空闲时间</div>
            </div>
            <div :class="{botHeader:true,even:i%2==0,odd:i%2!=0,translist:i==CarsIndex}" v-for="(item,i) in goods[0]">
              <div class="font16 cleartext">{{item.lc008?item.lc008:''}}</div>
              <div class="font16 cleartext">{{item.lc002}}-{{item.lc004}}</div>
              <div class="font16 cleartext">{{item.lc011 | formatTime}}</div>
            </div>
          </div>
         <router-link to="supplyOfGoods">
            <div class="center font16 bot-more">查看更多</div>
          </router-link>
        </el-card>
      </el-col>
      <el-col :span="24" :md="8" class="media-mt18">
        <el-card :body-style="{ padding: '0' }">
          <div class="bot-title">
            <div class="color font24">最新车源</div>
            <div class="font16"><router-link to='options'>更多</router-link></div>
          </div>
          <div class="eee">
            <div class="botHeader odd">
              <div class="font20">车辆类型</div>
              <div class="font20">车牌号</div>
              <div class="font20">空闲时间</div>
            </div>
            <div :class="{botHeader:true,even:i%2==0,odd:i%2!=0,translist:i==GoodsIndex}" v-for="(item,i) in cars[0]">
              <div class="font16 cleartext">{{item.ld005}}</div>
              <div class="font16 cleartext">{{item.ld002}}-{{item.ld003}}</div>
              <div class="font16 cleartext">{{item.ld004}}</div>
            </div>
          </div>
          <router-link to='options'>
            <div class="center font16 bot-more">查看更多</div>
          </router-link>
        </el-card>
      </el-col> -->


      <el-col :span="24" :md="8" class="media-mt18">
        <el-card :body-style="{ padding: '0' }">
          <div class="bot-title">
            <div class="color font24">充电站(桩)</div>
            <div class="font16"> <router-link to="charging">更多</router-link></div>
          </div>
          <div class="eee">
            <div class="botHeader odd">
              <div class="font20">充电桩地址</div>
              <div class="font20">价位</div>
              <div class="font20">充电功率</div>
            </div>
            <div :class="{botHeader:true,even:i%2==0,odd:i%2!=0,translist:i==ChargingIndex}" v-for="(item,i) in charging[0]">
              <div class="font16 cleartext">{{item.tg004}}</div>
              <div class="font16 cleartext">{{item.tg006}}-2.80</div>
              <div class="font16 cleartext">{{item.tg005 | formatG}}</div>
            </div>
          </div>
          <!-- <router-link to="charging">
            <div class="center font16 bot-more">查看更多</div>
          </router-link> -->
        </el-card>
      </el-col>
    </el-row>
    <div class="fixedCode">
      <img src="../../assets/floatimgV2.png" alt="">
    </div>
    <!-- <div class="fixedTips font14 center md-hide">
      <img src="../../assets/sun.png" alt="">
      <div>温度&nbsp;{{indexTips.temperature}}</div>
      <div>{{indexTips.windDirection}}</div>
      <div>{{week}} &nbsp; {{time | fromaDate}}</div>
      <div>{{day}}</div>
    </div> -->

  </div>
</template>

<script>
  // http://bigdatanew.bysunnm.com/#/logisticEnergyChart
  //import vLogisticEnergyChart from 'http://bigdatanew.bysunnm.com/#/logisticEnergyChart';
  export default {
    name: 'Index',
    data() {
      return {
        banner:[//require("../../assets/banner.png"),
                require("../../assets/banner2.png")],
        swiperList:[],
        func: [{
            icon: require('../../assets/icon11.png'),
            name: '车辆信息上报',
            url:'http://manage.sywlfz.com/#/login?usertype=2'
          },
          {
            icon: require('../../assets/icon12.png'),
            name: '货物信息上报',
            url:'http://manage.sywlfz.com/#/login?usertype=2'
          },
          {
            icon: require('../../assets/icon9.png'),
            name: '通行证申请/发放',
            url:'http://manage.sywlfz.com/#/login?usertype=2'
          },
          {
            icon: require('../../assets/icon1.png'),
            name: '车货配载',
            path:'/supplyOfGoods'
          },
          {
            icon: require('../../assets/icon13.png'),
            name: '意见建议',
            path:'/suggestion'
          },
          {
            icon: require('../../assets/icon10.png'),
            name: '投诉申诉',
            path:'/complaints'
          }
        ],
        webs: [{
            name: '交通运输局',
            web: 'http://jtys.shiyan.gov.cn/'
          },
          {
            name: '发改委',
            web: 'http://fgw.shiyan.gov.cn/'
          },
          {
            name: '交管局',
            web: 'http://www.syjg.gov.cn/'
          },
          {
            name: '经信局',
            web: 'http://jxw.shiyan.gov.cn/tzgg_16776/201912/t20191223_1926287.shtml'
          },
          {
            name: '邮管局',
            web: 'http://hbsy.spb.gov.cn/'
          },
          {
            name: '自规局',
            web: 'http://gtzy.shiyan.gov.cn/'
          },
          {
            name: '税务局',
            web: 'http://www.qianlima.com/02030101049dd/'
          },
          {
            name: '财政局',
            web: 'http://czj.shiyan.gov.cn/'
          },
          {
            name: '道路执法支队',
            web: 'http://syyg.shiyan.gov.cn/xxgk/'
          },
          {
            name: '水路执法支队',
            web: 'http://ghhs.shiyan.gov.cn/'
          },
          {
            name: '商务局',
            web: 'http://swj.shiyan.gov.cn/'
          },
          {
            name: '佰昌物流',
            web: 'http://www.bysunnm.com/'
          },
        ],
        Platform: {}, //平台数据
        state:[], //行业管理动态
        Policies: [], //政策法规
        environment: [], ////政策法规
        latest: [], //最新资讯
        //最新货源
        goods: [],
        goodsTimer: null,
        GoodsIndex: 0,
        //最新车源
        cars: [],
        carsTimer: null,
        CarsIndex: 0,
        //充电桩
        charging: [],
        chargingTimer: {}, //定时器
        ChargingIndex: 0, //充电桩切换索引

        yearEnergyData:[],//年能耗比
        energyValueData:[],//获取能耗值
      }
    },
    created() {
      this.getIndexRes();
      this.getCarEnergyValue();
    },
    components: { //组件
        // vLogisticEnergyChart
    },
    methods: {
      // 获取能耗值（单位周转能耗油，单位周转能耗电，吨公里成本，共同配送率）
      //UnitTransEnergyQty_Oil as field1, UnitTransEnergyQty_Elec as field2,DeliveryCost as field3, CommonDeliveryRate as field4
      getCarEnergyValue(){
        this.$axios.post("/api/carReport/getCarEnergyValue", {}).then(res => {
          this.energyValueData = res.data.data;
        })
          // let postData= new URLSearchParams()
          // this.$axios.post('/api/carReport/getCarEnergyValue',
          // postData).then(res => {
          //     if (res.data.code == 0) {
          //         if(res.data.data!=null && res.data.data.length>0)
          //         {
          //             this.energyValueData = res.data.data;
          //         }
          //     } else {
          //         console.log("获取能耗值数据错误,"+res.data.sub_msg);
          //     }
          // })
      },
      // 获取年能耗对比数据
      getCarYearEnergyList(){
        this.$axios.post("/api/carReport/getCarYearEnergyList", {}).then(res => {
          this.yearEnergyData = res.data.data;
        })

          // let postData= new URLSearchParams()
          // this.$axios.post('/api/carReport/getCarYearEnergyList',
          // postData).then(res => {
          //     if (res.data.code == 0) {
          //         if(res.data.data!=null && res.data.data.length>0)
          //         {
          //             this.yearEnergyData = res.data.data;
          //         }
          //         // this.drawBar_carYearEnergyListChartBar();
          //     } else {
          //         console.log("获取年能耗对比数据错误,"+res.data.sub_msg);
          //     }
          // })
      },
      getIndexRes() {
        //轮播图
        this.$axios.post('/api/banner/list', {
          skip: 0,
          pageSize: 15,
          where:' and isdelete = 0 and ak007=1 and ak006=1'
        }).then(res => {
          this.swiperList =  res.data.data.sort((a,b)=>(a.ak005-b.ak005));
        })
        //行业管理动态
        this.$axios.post('/api/news/list/49', {
          skip: 0,
          pageSize: 9,
          where:' and isdelete = 0 and ty009=1 order by ty006 desc'
        }).then(res => {
          this.state = res.data.data;
        })
        //政策法规
        this.$axios.post('/api/news/list/3', {
          skip: 0,
          pageSize: 9,
          where:' and isdelete = 0 and ty009=1 order by ty006 desc'
        }).then(res => {
          this.Policies = res.data.data;
        })
        //最新资讯
        this.$axios.post('/api/news/list/79', {
          skip: 0,
          pageSize: 3,
          where:' and isdelete = 0 and ty009=1 order by ty006 desc'
        }).then(res => {
          this.latest = res.data.data;
        })
        //营商环境
        this.$axios.post('/api/news/list/46', {
          skip: 0,
          pageSize: 8,
          where:' and isdelete = 0 and ty009=1 order by ty006 desc'
        }).then(res => {
          this.environment = res.data.data;
        })
        //平台数据
        this.$axios.post("/api/screen/data", {}).then(res => {
          this.Platform = res.data.data;
        })
        //货源
        this.$axios.post("/api/shippingInfo/getMallOrderList", {
          skip: 0,
          pageSize: 8
        }).then(res => {
          this.goods = this.spiltArr(res.data.data);
          if (res.data.data.length == 8) {
            this.roateList('GoodsIndex', 'goods', 'goodsTimer')
          }
        })
        //车源
        this.$axios.post("/api/shippingInfo/getCarInfoList", {
          skip: 0,
          pageSize: 8
        }).then(res => {
          this.cars = this.spiltArr(res.data.data);
          if (res.data.data.length == 8) {
            this.roateList('CarsIndex', 'cars', 'carsTimer')
          }
        })

        ////////////////////////2024-10-28 备份 Begin////////////////////////
        // //货源
        // this.$axios.post("/api/shippingInfo/list", {
        //   skip: 0,
        //   pageSize: 8
        // }).then(res => {
        //   this.goods = this.spiltArr(res.data.data);
        //   if (res.data.data.length == 8) {
        //     this.roateList('GoodsIndex', 'goods', 'goodsTimer')
        //   }
        // })
        // //车源
        // this.$axios.post("/api/truckInfo/list", {
        //   skip: 0,
        //   pageSize: 8
        // }).then(res => {
        //   this.cars = this.spiltArr(res.data.data);
        //   if (res.data.data.length == 8) {
        //     this.roateList('CarsIndex', 'cars', 'carsTimer')
        //   }
        // })
        ////////////////////////2024-10-28 备份 End  ////////////////////////

        //充电桩
        this.$axios.post("/api/chargingPile/list", {
          skip: 0,
          pageSize: 8,
          order: ' tg015 '
        }).then(res => {
          this.charging = this.spiltArr(res.data.data);
          if (res.data.data.length == 8) {
            this.roateList('ChargingIndex', 'charging', 'chargingTimer')
          }
        })
      },
      spiltArr(data) {
        let arr = [
          [],
          []
        ]
        try {
          data.forEach((ele, i) => {
            if (i % 2 == 0) {
              arr[1].push(ele)
            } else {
              arr[0].push(ele)
            }
          })
        } catch (e) {
          console.error('error spiltArr')
        }
        return arr;
      },
      roateList(i, dataName, timer) {
        this[timer] = setInterval(() => {
          let data = this[dataName];
          if (this[i] > 3) {
            this[i] = 0;
          }
          setTimeout(() => {
            let service = this[dataName][0][this[i]];
            this.$set(this[dataName][0], this[i], this[dataName][1][this[i]]);
            this[dataName][1][this[i]] = service;
            this[i] += 1;
          }, 2000)
        }, 3000)
      },
      toNewsInf(item) {
        let  {href} =  this.$router.resolve({
            name: 'Information',
            query: {
              newsId: item.quoteid
            }
        })
        window.open(href,"_blank")
      },
      navto(path) {
        if(path){
          let {href} =  this.$router.resolve({
            path
          })
          window.open(href,"_blank");
        }
      },
      navOutWeb(url){
        window.open(url,"_blank");
      },
      clickFunc(item){
        if(item.path){
          this.navto(item.path);
        }else{
          this.navOutWeb(item.url);
        }
      }
    },
    filters: {
      formatNum(value) {
        if (value) {
          if (value > 10000) {
            value /= 10000
          }
          return value.toFixed(0);
        } else {
          return 0;
        }
      },
      formatKgNum(value){
        if (value) {
          if (value > 1000000) {
            value /= 1000000
          }
          return value.toFixed(0);
        } else {
          return 0;
        }
      },
      formatTime(value) {
        let time = new Date(value)
        return time.getFullYear() + '/' + (time.getMonth() + 1) + '/' + time.getDate();
      },
      formatG(value) {
        if (value) {
          return parseInt(value).toFixed() + 'KW';
        } else {
          return '0KW';
        }
      },
    },
    destroyed() {
      clearInterval(this.chargingTimer);
      clearInterval(this.carsTimer);
      clearInterval(this.goodsTimer);
    }
  }
</script>

<style scoped>
  .index {
    overflow: hidden;
  }
  .custom>>>.el-carousel__container {
    height: 44.2rem !important;
  }

  .swiper-slide {
    display: block;
    width: 100%;
    height: 44.2rem;
    border-radius: 0.4rem;
  }

  .rules {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    font-size: 2.4rem;
    margin-top: 3.4rem;
  }

  .index-title,
  .morerule {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }

  .titleimg {
    display: block;
    width: 2.4rem;
    height: 2.4rem;
    margin-right: 0.5rem;
  }

  .morerule {
    font-size: 1.6rem;
    color: #9B9B9B;
  }

  .more {
    display: block;
    width: 1.2rem;
    height: 1.2rem;
    margin-left: 0.5rem;
  }

  ul {
    list-style-type: none;
    color: #333333;
    margin-top: 2rem;
  }

  ul img {
    display: block;
    width: 1.2rem;
    height: 1.2rem;
    margin-right: 0.5rem;
  }

  ul>li,
  .liimg {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }

  ul>li {
    margin-bottom: 1.6rem;
    height: 2.2rem;
  }

  ul>li:nth-child(9) {
    margin-bottom: 0;
  }

  .listimg {
    overflow: hidden;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin-top: 9.5rem;
  }

  .listimg img {
    display: block;
    width: 21rem;
    height: 15.4rem;
    border-radius: 0.4rem;
  }

  .banner {
    display: block;
    width: 100%;
    height: 11.4rem;
    /* margin: 3.3rem 0 2.4rem 0; */
  }

  .box-card {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .text-item {
    /*display: grid;*/
    /*grid-template-columns: 6.1rem 1fr;*/
    /*兼容ie*/
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    width: 17.9rem;
    height: 5.1rem;
    border-radius: 2rem;
    background-color: #F8F8F8;
    margin-bottom: 16px;
    cursor: pointer;
  }

  .text-item:nth-child(10),
  .text-item:nth-child(11),
  .text-item:nth-child(12) {
    margin-bottom: 0;
  }

  .text-item>img {
    display: block;
    width: 6.1rem;
    height: 5.1rem;
  }

  .text-item>div {
    flex: 1;
    text-align: center;
    font-size: 1.6rem;
    color: #333333;
  }

  .bg {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    height: 16.4rem;
    background-color: #0083CE;
    margin: 1.8rem 0;
  }

  .func {
    font-size: 2rem;
    color: white;
    margin-right: 6.1rem;
    margin-left: 3.1rem;
    cursor: pointer;
  }

  .func>img {
    display: block;
    width: 4.9rem;
    height: 4.3rem;
    margin: 0 auto 2.2rem;
  }

  .line {
    display: block;
    height: 8rem;
    width: 0;
    border-right: 1px dashed white;
  }

  .func-line {
    /*display: grid;*/
    /*grid-template-columns: 1fr 1px;*/
    display: flex;
    align-items: center;
  }
  .func-line >span{
    width: 1px;
  }

  .resource {
    height: 30.5rem;
    background-image: url(../../assets/icon8.png);
    background-size: 100%;
    background-repeat: no-repeat;
    /*padding: 16px 0;*/
    text-align: center;
  }

  .reduce {
    background-image: url(../../assets/icon6.png);
  }

  .resource-box {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
  }

  .resitem {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    width: 33.3%;
  }

  .linesolid {
    display: block;
    height: 8rem;
    width: 0;
    border-right: 2px solid #999999;
    margin-top: -1.7rem;
  }

  .bot-title {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.6rem;
    height: 6.3rem;
    line-height: 6.3rem;
  }

  .botHeader {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
  }

  .botHeader>div {
    box-sizing: border-box;
    width: 30%;
    height: 4.7rem;
    line-height: 4.7rem;
    text-align: center;
    padding: 0 1.6rem;
  }

  .translist {
    transform: rotateX(360deg) !important;
    transition: all 2s;
    transition-delay: 0.5s;
  }

  .fixedCode,.fixedTips{
    overflow: hidden;
    position: fixed;
    top: 55rem;
    z-index: 99;
    width: 16.2rem;
    height: 20rem;
    box-shadow: 0 0.6rem 1.2rem #DCDCDC;
    border-radius: 0.8rem;
  }
  .fixedCode {
    right: 5rem;
  }
  .fixedCode > img {
    display: block;
    width: 16.2rem;
    height: 20rem;
  }
  .fixedTips{
   left: 5rem;
   height: auto;
   color: #333333;
   padding: 1.5rem 0;
  }
  .fixedTips >img{
    display: block;
    width: 6rem;
    height: 5.2rem;
    margin: 0.3rem auto 2.3rem;
  }
 .index-swiper-item{
    position: relative;
  }
  .swiper-text{
    box-sizing: border-box;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 99;
    font-size: 1.6rem;
    color: white;
    height: 6rem;
    line-height: 6rem;
    width: 100%;
    padding: 0 2.1rem;
  }
  .transbg{
    position: absolute;
    top:0;
    left: 0;
    height: 6rem;
    width: 100%;
    background-color: #000000;
    opacity: 0.3;
    z-index: -1;
  }
  >>>.el-carousel__arrow{
    background-color: #666;
  }
  .imgtext{
    position: relative;
  }
  .text-name{
    position: absolute;
    top: 1.5rem;
    left: 1.6rem;
    color: white;
    font-size: 2rem;
  }
  .even {
    color: #333333;
    background-color: #F6F7F9;
  }

  .odd {
    color: #333333;
    background-color: #ECECEC;
  }

  .bot-more {
    height: 5.3rem;
    line-height: 5.3rem;
    background-color: white;
  }

  .pad {
    padding: 2.3rem 0;
    margin: 0 auto;
  }
  .red{
    color: #EE551B;
  }

  .mt0 {
    margin-top: 0;
  }

  .mt14 {
    margin-top: 1.4rem;
  }

  .mt24 {
    margin-top: 2.1rem;
  }

  .mt48 {
    margin-top: 4.8rem;
  }

  .mb53 {
    margin-bottom: 53px;
  }

  .mt18 {
    margin-top: 1.8rem;
  }

  .left {
    text-align: left;
  }

  .right {
    text-align: right;
  }

  .center {
    text-align: center;
  }

  .text {
    display: block;
    width: 42rem;
  }

  .pr100 {
    padding-left: 20rem;
  }



  .mt26 {
    margin-top: 2.6rem;
  }

  .mb24 {
    margin-bottom: 2.4rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/index.vue